<template>
    <rkm-modal
        extra-large
        persistent
        ref="Modal"
        title="Solicitação"
    >
        <Form
            :key="formKey"
            :posicao-por-regulador="posicaoPorRegulador"
            :solicitacao="solicitacao"
            @prioridade-change="$emit('prioridade-change')"
            @save="handleSave"
            @data-change="data = $event"
            @visualizar-solicitacao-click="handleVisualizarSolicitacaoClick"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading || disableCancel"
                @click="cancel"
            >
                {{ solicitacao?.allowUpdate ? 'Cancelar' : 'Fechar' }}
            </rkm-button>

            <rkm-button
                v-if="solicitacao?.allowUpdate ?? false"
                :disabled="!!loading"
                @click="$refs.Form.handleSave()"
                color="primary"
            >
                {{ buttonSaveText }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Mixins.
import { repository, error } from '@/mixins'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        disableCancel() {

            return this.data && this.data.fezAgendamentoAgora
        },
        buttonSaveText() {

            if (this.data && this.data.isPrestadorTipoInterno && !this.data.fezAgendamentoAgora) {

                if (this.data.isStatusAgendado) {

                    return 'Agendar e salvar'
                }
                else if (this.data.isStatusReagendado) {

                    return 'Reagendar e salvar'
                }
            }

            return 'Salvar'
        },
    },
    created() {
        this.repositories = {
            fila: this.getConectaSusRepository('regulacao.fila'),
        }
    },
    data: () => ({
        solicitacao: null,
        data: null,
        posicaoPorRegulador: false,
        formKey: 1,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(solicitacao, posicaoPorRegulador) {
            this.solicitacao = solicitacao
            this.posicaoPorRegulador = posicaoPorRegulador

            this.$refs.Modal.show()
        },
        handleSave() {
            this.$emit('save')

            this.setLoading()

            this.repositories.fila.getSolicitacaoFromDatatable(this.solicitacao.id)
                .then(({ data }) => {
                    this.solicitacao = data
                    this.data = null
                    this.formKey++
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleVisualizarSolicitacaoClick(solicitacaoId) {
            this.setLoading()

            this.repositories.fila.getSolicitacaoFromDatatable(solicitacaoId)
                .then(({ data }) => {
                    this.solicitacao = data
                    this.data = null
                    this.posicaoPorRegulador = true
                    this.formKey++
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, error],
}
</script>